import * as s from "pages/recorders/RecordersStyled";
import BigButton from "components/atoms/buttons/BigButton";
import {
  FirmwareUpdateInfoResult,
  FIRMWARE_UPGRADE_STATUS,
  FIRMWARE_UPDATE_STEP,
} from "api/interfaces/settingsInterface.interface";
import { updateMessage } from "utils/firmwareUtil";
import StepBar from "components/atoms/step/StepBar";

export default function FirmwareSuccess({
  data,
  percent,
  onClickCancel,
}: {
  data: FirmwareUpdateInfoResult;
  percent: number;
  onClickCancel: () => void;
}) {
  return (
    <s.UpdateFirmwareStyled.Wrapper>
      <s.UpdateFirmwareStyled.UpdateStatus>
        {updateMessage[FIRMWARE_UPGRADE_STATUS.COMPLETE]}
      </s.UpdateFirmwareStyled.UpdateStatus>
      <StepBar percent={percent} steps={5} />
      <s.UpdateFirmwareStyled.InfoWrapper>
        <s.UpdateFirmwareStyled.Version.Label
          status={FIRMWARE_UPDATE_STEP.SUCCESS}
        >
          <span>Current Version</span>
          <b>Version {data.currentVersion}</b>
        </s.UpdateFirmwareStyled.Version.Label>
      </s.UpdateFirmwareStyled.InfoWrapper>
      <s.UpdateFirmwareStyled.Buttons>
        <BigButton
          onClickBtn={onClickCancel}
          label="Close"
          buttonType="cancel"
          data-testid="recorders-edit-step-button-click-cancel"
        />
      </s.UpdateFirmwareStyled.Buttons>
    </s.UpdateFirmwareStyled.Wrapper>
  );
}
